// extracted by mini-css-extract-plugin
module.exports = {"normal":"controlButton_normal__20N-_","clicked":"controlButton_clicked__3RFJz"};